import InsuranceTour from './views/InsuranceTour';
export default InsuranceTour;
